import React, { useRef, useState } from 'react';
import style from './FlashCard.module.css';

import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { EffectFlip  } from 'swiper';
import 'swiper/swiper-bundle.css';

import { motion } from 'framer-motion';
import icons from '../../../../../icons';


SwiperCore.use([ EffectFlip ]);

const DRAG_THRESHOLD = 100;
let dragStart = {};

const FlashCard = React.forwardRef((props, ref) => {
    const [swipeRight, setSwipeRight] = useState(false);
    const swiper = useRef();

    const variants = {
        animate: {
            zIndex: -props.idx,
        },
        done: {
            zIndex: 1,
            x: swipeRight ? "100vw" : "-100vw",
            y: `0`,
            opacity: 0,
        }
    };

    const turnCard = () => swiper.current.swiper.slideTo(swiper.current.swiper.activeIndex === 0 ? 1 : 0);

    return <motion.div 
        drag="x"
        dragConstraints={{ top: 1, bottom: 0, left: 0, right: 1 }} 
        whileDrag={{ scale: 0.9 }}
        onDragStart={ e => dragStart = { x: e.x, y: e.y } } 
        onDragEnd={ e => {
            if (swiper.current.swiper.activeIndex === 1)
                return;

            if (Math.abs(e.x - dragStart.x) >= DRAG_THRESHOLD && e.x !== 0)
                setSwipeRight(e.x - dragStart.x > 0);

            if (e.x - dragStart.x >= DRAG_THRESHOLD && e.x !== 0)
                props.setDone(props.card.id, true);

            if (dragStart.x - e.x >= DRAG_THRESHOLD && e.x !== 0)
                props.setDone(props.card.id, false);
        } }
        variants={ variants }
        transition={{ duration: .1 }}
        animate="animate"
        exit={ "done" }
        layout
        className={ style.main }>
        <Swiper ref={ swiper } flipEffect={ true } effect="flip" loop={ true } allowTouchMove={ false } style={{ transitionProperty: "transform, opacity", transition: "all .5s ease", transform: `translate(${2 * props.idx + "%"}, ${-80 * Math.abs(props.idx) + "%"})`, opacity: 1 }}>
            <SwiperSlide>
                <motion.div className={ style.cardFace } initial={{ background: `linear-gradient(to bottom right, ${props.card.color[0]}, ${props.card.color[1]})` }} animate={{ background: `linear-gradient(to bottom right, ${props.card.color[0]}, ${props.card.color[1]})`, width: `calc(100vw - ${3 * props.idx || 2}rem)` }}>
                    <img src={ icons.question_mark_white_icon } style={{ position: "absolute", left: ".5rem", top: ".5rem" }} onClick={ props.showFlashcardsTutorial }></img>
                    <div className={ style.currentBox }>
                        <img src={ icons.box_white_icon }></img>
                        <h6>{ props.card.box }</h6>
                    </div>
                    <h1 className={ style.mainHeader }>{ props.card.question }</h1>
                    { props.idx === 0 && <div className={ style.btn } onClick={ turnCard }>
                        <h5>RISPOSTA</h5>
                        <img src={ icons.visibility_white_icon }></img>
                    </div> }
                </motion.div>
            </SwiperSlide>
            <SwiperSlide>
                <motion.div className={ style.cardFace } style={{ position: "relative", display: "grid", alignContent: "center" }} initial={{ background: `linear-gradient(to bottom right, ${props.card.color[0]}, ${props.card.color[1]})` }} animate={{ background: `linear-gradient(to bottom right, ${props.card.color[0]}, ${props.card.color[1]})`, width: `calc(100vw - ${3 * props.idx || 2}rem)` }}>
                    <h1 className={ style.mainHeader } style={{ marginTop: "0" }}>{ props.card.answer }</h1>
                    <img src={ icons.visibility_off_white_icon } style={{ position: "absolute", right: ".5rem", top: ".5rem" }} onClick={ turnCard }></img>
                    <img src={ icons.edit_white_icon } style={{ position: "absolute", top: "1rem", left: "1rem" }} onClick={ () => {
                        props.setAddProps({ type: "flashcard", ...props.card, category: props.categoryId });
                        props.showAdd(true);
                    } }></img>
                </motion.div>
            </SwiperSlide>
        </Swiper>
    </motion.div>
});

export default FlashCard;